import { DefaultApi } from '../autogenerated/spdApiClient';

export interface PrinterTokenContextInterface {
  getToken: (url: string) => Promise<{
    token: string | null;
    expiresAt: string | null;
  }>;
  acquireLock: (
    url: string,
    clientId: string,
    ttlSeconds?: number,
  ) => Promise<{ acquired: boolean; lockExpiresAt: string | null }>;
  setToken: (
    url: string,
    clientId: string,
    token: string,
    expiresAt: string,
  ) => Promise<void>;
  releaseLock: (url: string, clientId: string) => Promise<void>;
}

export const PrinterTokenContext = (
  api: DefaultApi,
): PrinterTokenContextInterface => ({
  getToken: async url => {
    const response = await api.fiscalPrinterLocationControllerGetToken(url);
    return {
      token: response.token ?? null,
      expiresAt: response.expiresAt ?? null,
    };
  },
  acquireLock: async (url, clientId, ttlSeconds) => {
    const response = await api.fiscalPrinterLocationControllerAcquireLock({
      url,
      clientId,
      ttlSeconds,
    });
    return {
      acquired: response.acquired,
      lockExpiresAt: response.lockExpiresAt ?? null,
    };
  },
  setToken: async (url, clientId, token, expiresAt) => {
    await api.fiscalPrinterLocationControllerSetToken({
      url,
      clientId,
      token,
      expiresAt,
    });
  },
  releaseLock: async (url, clientId) => {
    await api.fiscalPrinterLocationControllerReleaseLock({ url, clientId });
  },
});
